module.exports = __webpack_public_path__ + "img/5.2dadde2b.webp";